/** Points per Genius round (0-based index). Rounds 1–4: 2; 5–7: 3; 8–10: 5. */
export function geniusPointsForRound(roundIndexZeroBased: number): number {
  if (roundIndexZeroBased >= 7) return 5;
  if (roundIndexZeroBased >= 4) return 3;
  return 2;
}

export const GENIUS_TOTAL_ROUNDS = 10;

/** Alinhado a `QuizSettings.SoloQuestionTimeLimitSeconds` (solo MC / docs). */
export const GENIUS_TIME_LIMIT_SECONDS = 30;
